import React, { useState } from 'react'

// components
import SideViewModal from '../../../../../components/modals/SideViewModal/SideViewModal.component'

// collections
import MarkAsPaidForm from './MarkAsPaid.form'

// queries
import { useMutation } from '@apollo/client'
import { GET_JOB_DAY_BY_ID_WITH_ASSIGNMENTS_FOR_APPROVAL, GET_JOB_DAY_WITH_NAME_DATE_AND_STATUS } from '../../../../../graphql/jobDay/jobDay.queries'
import { apolloClient } from '../../../../..'
import { MARK_CREW_MEMBER_ASSIGNMENTS_AS_PAID_MUTATION } from '../../../../../graphql/crewMemberAssignment/crewMemberAssignment.mutations'

// utils

import moment from 'moment'

const approvalStateReference = {
    "preliminary": "Approve Time Tickets",
    "final": "Approve Time Tickets"
}

const validationSchema = {
    date: {
        type: 'date',
        validation: {
            required: true,
            isDate: true
        }
    }
}

export default function MarkAsPaidFormController({ id, approvalStage, visible, closeForm }) {
    const [isFetchingObject, setIsFetchingObject] = useState(true)
    const [assignments, setAssignments] = useState(null)
    const [jobDay, setJobDay] = useState(null)
    const [markAsPaid] = useMutation(MARK_CREW_MEMBER_ASSIGNMENTS_AS_PAID_MUTATION)
    const [errors, setErrors] = useState({})

    const handleSubmit = (formData) => {
        markAsPaid({ 
            variables: {
                assignments: formData.assignments.map(assignment => parseInt(assignment.id, 10)),  // ✅ Integers
                paidDate: formData.paidDate.format("YYYY-MM-DD")
            }, 
            refetchQueries: [GET_JOB_DAY_WITH_NAME_DATE_AND_STATUS]
        })
        .catch(e => console.error(e))
        .then(result => {
            if(result) {
                closeForm()
            }
        })
    }

    if(visible && isFetchingObject) {
        apolloClient.query({ query:GET_JOB_DAY_BY_ID_WITH_ASSIGNMENTS_FOR_APPROVAL, variables: { id }}).catch(e => {})
        .then(result => {
            if(result) {
                setAssignments(result.data.jobDay.crewMemberAssignments)
                setJobDay({ job: result.data.jobDay.job, scope: result.data.jobDay.scopeOfWork})
                setIsFetchingObject(false)
            }
        })

        return null
    }

    else if(visible && !isFetchingObject && assignments) {
        const editVariants = [
            {
                name: 'Mark as Paid',
                component: <MarkAsPaidForm />,
                stages: 1
            }
        ]

        return (<SideViewModal 
            show={visible} 
            submitText={'Mark as Paid'}
            onClose={() => {
                setErrors({})
                closeForm()
            }}  
            onSubmit={handleSubmit}
            title={'Mark as Paid'}
            variants={editVariants}
            prefillData={{assignments, jobDay}}
            errors={errors}
        />)
    }

    return null
}

